import React from 'react';
import logo from './logo.svg';
import { Route, Routes, BrowserRouter } from 'react-router';
import './App.css';
import './Components/InnerComponents/IComponents.css';
import './Components/PageElements/Stylesheets/Home.css';
import Home from './Components/PageElements/Home';
import Navbar from './Components/InnerComponents/Navbar';
import AdminLogin from './Components/PageElements/AdminLogin';
import CreatePost from './Components/PageElements/CreatePost';
import Post from './Components/PageElements/Post';
import Portfolio from './Components/PageElements/Portfolio';
import Gallery from './Components/PageElements/CategPortfolio';
import AdminControlPanel from './Components/PageElements/AdminControlPanel';
import Unauth from './Components/PageElements/Unauth';
import Contact from './Components/PageElements/Contact';
import Footer from './Components/InnerComponents/Footer';

import { createContext, useState } from 'react';

type ScreenBusyContextType = {
    screenBusy: boolean;
    setScreenBusy: React.Dispatch<React.SetStateAction<boolean>>;
}
export const ScreenBusyContext = createContext<ScreenBusyContextType | null>(null);

function App() {

  const [screenBusy, setScreenBusy] = useState(false);
  return (
    <>
    <ScreenBusyContext.Provider value={{screenBusy, setScreenBusy}} >
      <Navbar />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/adminlogin" element={<AdminLogin />} />
          <Route path="/createpost" element={<CreatePost />} />
          <Route path="/post/:postId" element={<Post />} />
          <Route path="/Portfolio" element={<Portfolio />} />
          <Route path="/Gallery/:category" element={<Gallery />} />
          <Route path="/admin" element={<AdminControlPanel />} />
          <Route path="/denied" element={<Unauth />} />
          <Route path="/denied" element={<Unauth />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter> 
      </ScreenBusyContext.Provider >
      <Footer />
    </>
  );
}

export default App;
